import {observer} from 'mobx-react';
import RecruitingSubnav from 'main/containers/recruiting/components/RecruitingSubnav';
import EmailTemplateContainerWithState from 'main/containers/recruiting/components/email_templates/EmailTemplateContainerWithState';

const EmailTemplateContainer = observer(({history}) => {

  return (
    <div>
      <RecruitingSubnav />
      <EmailTemplateContainerWithState history={history} />
    </div>
  );
});

export default EmailTemplateContainer;
